export default "/images/insta-logo.png?12f9e09fc0cf07a9ac1faff4ed70bf7c";